"use client";

import { useCallback, useMemo } from "react";
import { type Situation } from "@/generated/fastapi";

export default function useSituationAccessors(situations?: Situation[] | null) {
  const safeSituations = useMemo(() => situations ?? [], [situations]);

  const situationsMap = useMemo(
    () => new Map(safeSituations.map((situation) => [situation.id, situation])),
    [safeSituations],
  );

  const getSituationById = useCallback(
    (situationId: string) => situationsMap.get(situationId),
    [situationsMap],
  );

  return {
    situations: safeSituations,
    situationsMap,
    getSituationById,
  };
}
